import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { di } from 'react-magnetic-di';
import Link from '@atlaskit/link';
import { Spotlight, SpotlightManager, SpotlightPulse, SpotlightTarget, SpotlightTransition } from '@atlaskit/onboarding';
import { BUTTON_SPOTLIGHT_TARGET_NAME, FORM_RESTRICTION_URL } from '../../../common/constants';
import FormPermissionOnboardingImage from './assets/form-permission-onboarding.svg';
import { messages } from './messages';
export const PulseSpotlightOnboarding = ({
  showOnboarding,
  children,
  onDismiss,
  onProceed
}) => {
  const {
    formatMessage
  } = useIntl();
  const [onboardingStep, setOnboardingStep] = useState('none');
  const showPulse = onboardingStep === 'pulse';
  const showSpotlight = onboardingStep === 'spotlight';
  useEffect(() => {
    if (showOnboarding) {
      setOnboardingStep('pulse');
    } else {
      setOnboardingStep('none');
    }
  }, [showOnboarding]);
  const onClickWithOnboarding = onClick => (event, analyticsEvent) => {
    event.stopPropagation();
    switch (onboardingStep) {
      case 'pulse':
        {
          setOnboardingStep('spotlight');
          return;
        }
      case 'none':
        {
          return onClick(event, analyticsEvent);
        }
      case 'spotlight':
      default:
    }
  };
  const handleProceed = (event, analyticsEvent) => {
    setOnboardingStep('none');
    onProceed(event, analyticsEvent);
  };
  const handleDismiss = () => {
    setOnboardingStep('none');
    onDismiss();
  };
  return /*#__PURE__*/React.createElement(SpotlightManager, null, /*#__PURE__*/React.createElement(SpotlightTarget, {
    name: BUTTON_SPOTLIGHT_TARGET_NAME
  }, /*#__PURE__*/React.createElement(SpotlightPulse, {
    radius: 3,
    pulse: showPulse
  }, children(onClickWithOnboarding))), /*#__PURE__*/React.createElement(SpotlightTransition, null, showSpotlight && /*#__PURE__*/React.createElement(Spotlight, {
    target: BUTTON_SPOTLIGHT_TARGET_NAME,
    key: BUTTON_SPOTLIGHT_TARGET_NAME,
    heading: formatMessage(messages.spotlightHeading),
    actions: [{
      text: /*#__PURE__*/React.createElement(FormattedMessage, messages.spotlightPrimaryButton),
      onClick: handleProceed
    }, {
      text: /*#__PURE__*/React.createElement(FormattedMessage, messages.spotlightSecondaryButton),
      onClick: handleDismiss,
      appearance: 'subtle'
    }],
    targetRadius: 3,
    targetBgColor: "var(--ds-surface-raised, #FFFFFF)",
    dialogWidth: 280,
    dialogPlacement: "bottom left",
    image: FormPermissionOnboardingImage
  }, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.spotlightContent, {
    values: {
      link: chunks => /*#__PURE__*/React.createElement(Link, {
        appearance: "inverse",
        href: FORM_RESTRICTION_URL,
        target: "_blank"
      }, chunks)
    }
  })))));
};